import { useTranslation } from 'react-i18next';

import { ChecklistColumns, OtherField } from './components';
import { getEvidencedBasedInterventionsData } from '../../constants';
import { getEvidenceBasedInterventionItems } from './utils';

import type { EvidenceBasedInterventionsProps } from './types';

function EvidencedBasedInterventions({
  data,
  errorMessage,
  hasError,
  isEditable,
  onChange,
  subtitle,
  title,
  useNewUi,
}: EvidenceBasedInterventionsProps) {
  const { t } = useTranslation('sessionNotes');

  return (
    <ChecklistColumns
      title={title}
      subtitle={subtitle}
      errorMessage={errorMessage}
      hasError={hasError}
      items={getEvidenceBasedInterventionItems(getEvidencedBasedInterventionsData(t), data)}
      isEditable={isEditable}
      useNewUi={useNewUi}
      onChange={onChange}
      footer={
        <OtherField
          dataTestId="inputTypeForOtherEvidencedBasedInterventions"
          label={t('evidenceBasedInterventionsUsed.fields.other')}
          legacyLabel={t('evidenceBasedInterventionsUsed.fields.other')}
          legacyPlaceholder={t('evidenceBasedInterventionsUsed.fields.other')}
          placeholder="Explain other"
          value={data.other}
          disabled={!isEditable}
          useNewUi={useNewUi}
          onChange={onChange}
        />
      }
    />
  );
}

export default EvidencedBasedInterventions;
